<div class="t-widget">
  <h3 class="t-widgetTitle">
    <ng-container>
      {{ titleStr | translate }}
      <span *ngIf="subtitle">{{ subtitle }}</span></ng-container
    >
    <ng-container *ngTemplateOutlet="addFileLink"></ng-container>
  </h3>
  <hr />

  <ui-table
    [isWrapped]="false"
    [dense]="true"
    [showPaginator]="false"
    [data]="files"
    (onRowSelect)="onFileClicked($event)"
    [templates]="[
      {
        title: 'translate.order.filePreview',
        template: preview
      },
      {
        title: 'translate.general.fileDate',
        template: uploadDateFormatted
      },
      {
        title: 'translate.order.RXDownloadStatus',
        template: downloadStatus,
        permission: false
      }
    ]"
    [footerTemplate]="allowUpload ? addFileFooter : null"
    [scrollable]="isScrollable && files.length > 6 ? true : false"
    scrollHeight="{{ isScrollable && files.length > 6 ? '400px' : '400px' }}"
    class="t-scrollbar"
  ></ui-table>
</div>

<ng-template #preview let-row="row">
  <!--existing file-->
  <div *ngIf="!row.uploadStatus || row.uploadStatus == 'SUCCESS'">
    <file-icon [file]="row"></file-icon>
  </div>

  <!--uploading-->
  <spinner *ngIf="row.uploadStatus == 'PROGRESS'" class="l-ta-center"></spinner>

  <!--error-->
  <i
    *ngIf="row.uploadStatus == 'ERROR'"
    class="fas l-ta-center fa-times c-warn"
  ></i>
</ng-template>

<ng-template #uploadDateFormatted let-row="row">
  <span>{{ row.uploadDateFormatted }}</span>
</ng-template>

<ng-template #downloadStatus let-row="row">
  <i
    *ngIf="row.lastDownloadTimestamp"
    tooltip="{{ 'translate.order.RXDownloadedBy' | translate }} {{
      row.lastDownloadUserDescr
    }} ({{ row.lastDownloadTimestamp }})"
    class="fas fa-check c-success"
  >
  </i>

  <i *ngIf="!row.lastDownloadTimestamp" class="fas fa-times c-warn"> </i>
</ng-template>

<ng-template #addFileFooter>
  <tr>
    <th colspan="2" class="th-footer">
      <div
        class="file-drop-container"
        appDnd
        (fileDropped)="onFilesDropped($event)"
      >
        <div *ngIf="!isUploading">
          <input
            id="uploadFileInput"
            (change)="onFilesSelected($event)"
            class="t-fileInput-spread"
            type="file"
            multiple
            [accept]="validFileTypesStr"
          />

          <!-- accept=".pdf,.jpg,.jpeg,.png,.html" -->
          <img src="assets\img\Add_Image.svg" />
        </div>
        <spinner *ngIf="isUploading" class="l-ta-center"></spinner>

        <span class="note">
          {{ "translate.validation.pdfOrJpgOnly" | translate }}</span
        >
      </div>
    </th>
  </tr>
</ng-template>

<p-dialog
  *ngIf="
    selectedFile &&
    store.selectSignal(currentDisplayedFileId)() === selectedFile.fileId
  "
  [(visible)]="filePopupDisplay"
  [modal]="false"
  [draggable]="true"
  [resizable]="true"
  [closable]="false"
  (onHide)="
    filePopupDisplay = false;
    selectedFile = null;
    store.dispatch(CLEAR_DISPLAYED_FILE())
  "
>
  <file-preview
    [fileList]="files"
    [currentFile]="selectedFile"
    (onClose)="filePopupDisplay = false; selectedFile = null"
    [showSendInChat]="true"
  ></file-preview>
</p-dialog>

<ng-template #addFileLink>
  <a *ngIf="showCreateRx" (click)="createRX()" class="note"
    >+ {{ "translate.order.createRX" | translate }}</a
  >
</ng-template>
